import React, { PureComponent } from 'react';

import { Form, FormGroup, SubmitButton } from '../../../components/Forms/Forms';
import { Input, Select } from '../../../components/Forms/fields';
import TransactionsFilters from './TransactionFilters';
import enums from '../../../constants/enums';
import Auth from '../../../libs/Auth';

class TransactionsView extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      expanded: {}
    };
  }
  toggle(id){
    const { expanded } = this.state;
    this.setState({
      expanded: {
        ...expanded,
        [id]: !expanded[id]
      }
    });
  }
  render() {
    let {
      transactions,
      page,
      nextPage,
      previousPage,
      formState,
      submitForm,
      onFormUpdate,
      addOrder,
      removeOrder,
      toggleEdit,
    } = this.props;

    return (
      <div className="admin-transactions-view">
        <TransactionsFilters {...this.props} />
        <div className="page">
          <table>
            <thead>
            <tr>
              <th>User</th>
              <th>SKU</th>
              <th>#</th>
              <th>Value</th>
              <th>Created</th>
              <th>Modified</th>
              <th>Payment Status</th>
              <th>Return Status</th>
              <th>Checkout Status</th>
              <th>complete Status</th>
              <th>Paid</th>
              <th>Shipped</th>
              <th>Amazon Status</th>
              <th>Amazon Order #</th>
              <th></th>
            </tr>
            </thead>

            {transactions.map((transaction, i)=>{
              const editing = this.props.editing && formState.data._id === transaction._id;
              return (
                <tbody key={transaction._id}>
                <tr className={i%2 ? 'even' : 'odd'}>
                  <td>{transaction.ebayAccountUserId}</td>
                  <td>{transaction.SKU}</td>
                  <td>{transaction.quantityPurchased}</td>
                  <td>{transaction.value}</td>
                  <td>{transaction.createdDate}</td>
                  <td>{transaction.lastModifiedDate}</td>
                  <td>{transaction.eBayPaymentStatus}</td>
                  <td>{transaction.returnStatus}</td>
                  <td>{transaction.checkoutStatus}</td>
                  <td>{transaction.completeStatus}</td>
                  <td>{transaction.paidTime}</td>
                  <td>{transaction.shippedTime}</td>
                  <td>{transaction.orders.length && transaction.orders[0].status}</td>
                  <td>{transaction.orders.length && transaction.orders[0].orderNumber}</td>
                  <td>
                    <div className="action-buttons">
                      <button onClick={() => this.toggle(transaction._id)}><i className="fi-arrows-out size-18"></i> view more</button>
                    </div>
                  </td>
                </tr>
                {this.state.expanded[transaction._id] && (
                  <tr>
                    <td colSpan="15">
                      <Form element="div" state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
                        <table>
                          <thead>
                          <tr>
                            <th>Status</th>
                            <th>Order Number</th>
                            <th></th>
                          </tr>
                          </thead>
                          <tbody>
                          {editing ? (
                            formState.data.orders.map((order, i) => (
                              <tr key={i}>
                                <td>
                                  <FormGroup>
                                    <Select
                                      name={`orders[${i}].status`}
                                      options={enums.orderStatus}
                                    />
                                  </FormGroup>
                                </td>
                                <td>
                                  <FormGroup>
                                    <Input name={`orders[${i}].orderNumber`} type="text" />
                                  </FormGroup>
                                </td>
                                <td>
                                  <button className="button" type="button" onClick={() => removeOrder(i)}>-</button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            transaction.orders.map((order, i) => (
                              <tr key={i}>
                                <td>{order.status}</td>
                                <td>{order.orderNumber}</td>
                                <td>

                                </td>
                              </tr>
                            ))
                          )}
                          </tbody>
                        </table>
                        <div className="actions">
                          {editing ? (
                            <div>
                              <button className="button" type="button" onClick={addOrder}>+</button>
                              <button className="button" type="button" onClick={() => toggleEdit(transaction)}>Cancel</button>
                              <SubmitButton className="button">Save</SubmitButton>
                            </div>
                          ) : (
                            <div>
                              <button className="button" type="button" onClick={() => toggleEdit(transaction)}>Edit</button>
                            </div>
                            )}
                        </div>

                      </Form>

                    </td>


                  </tr>
                )}
                </tbody>
              );
            })}
            <tbody>
            <tr>
              <td colSpan="13">
                <ul className="pagination">
                  <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                    {page > 1  ? (
                      <a onClick={e=>{
                        e.preventDefault();
                        previousPage();
                      }}>Previous</a>
                    ) : 'Previous'}

                  </li>
                  <li>{page}</li>
                  <li className="pagination-next">
                    <a onClick={e=>{
                      e.preventDefault();
                      nextPage();
                    }}>Next</a>
                  </li>
                </ul>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>
    );
  }
}

export default TransactionsView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/Transactions.view.js